import { Car, BatteryCharging, Network, Handshake, Radio, HardHat, TrendingUp, Shield } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const HIGHWAY_IMG = "/assets/truck-highway.jpg";

const SERVICES = [
  {
    icon: Car,
    title: "EV Vehicles",
    desc: "Optimized vehicles acquired with competitive pricing.",
  },
  {
    icon: BatteryCharging,
    title: "Charging Infra",
    desc: "Co-developed for reliable fleet powering solutions.",
  },
  {
    icon: Network,
    title: "Integrated Solution",
    desc: "End-to-end Electric Mobility as a Service designed specifically for enterprise clients.",
  },
  {
    icon: Handshake,
    title: "OEM Tie Ups",
    desc: "Vehicle configurations to deliver maximum performance per client needs.",
  },
  {
    icon: Radio,
    title: "Tech & Telematics",
    desc: "Real-time telematics paired with advanced driver assistance.",
  },
  {
    icon: HardHat,
    title: "Operations",
    desc: "Robust operations management and regional partner integration.",
  },
  {
    icon: TrendingUp,
    title: "Scaled Operations",
    desc: "Scaled mobility and streamlined fleet operations to deliver high customer value.",
  },
  {
    icon: Shield,
    title: "Derisked Financials",
    desc: "Long-term contracts to enhance IRR visibility through coverage of fixed costs.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <Overline>Capabilities</Overline>
            <h2 className="mt-6 font-display text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">
              The ElectroHaul <span className="text-volt">Platform</span>
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-smoke md:text-base">
              A comprehensive eMobility-as-a-Service solution for enterprise
              clients.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="hidden lg:col-span-5 lg:block">
            <div className="spotlight clip-tech-sm relative ml-auto w-4/5">
              <img
                src={HIGHWAY_IMG}
                alt="ElectroHaul branded electric truck hauling freight on the highway"
                data-testid="services-truck-image"
                className="h-36 w-full object-cover"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 border-l border-t border-line md:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`service-card-${i + 1}`}
                className="group relative flex h-full flex-col justify-between overflow-hidden border-b border-r border-line p-6 transition-colors duration-500 hover:border-volt/50 md:p-8"
              >
                <span className="absolute inset-x-0 top-0 h-[2px] origin-left scale-x-0 bg-volt transition-transform duration-500 ease-out group-hover:scale-x-100" />
                <div>
                  <div className="flex justify-center">
                    <span className="clip-tech-sm flex h-14 w-14 items-center justify-center border border-volt/40 bg-ash transition-colors duration-300 group-hover:border-volt">
                      <s.icon className="h-6 w-6 text-volt" />
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-lg font-medium tracking-tight sm:text-xl">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-smoke">{s.desc}</p>
                </div>
                <span className="mt-8 block h-px w-full bg-line transition-colors duration-500 group-hover:bg-volt/40" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
